import React from "react"
import MConditionalLink from "./m_conditional_link"
import Section from "./section"

const MRelatedLinks = props => {
  return (
    <Section
      baseClass="m-RichText"
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-RichText-wrapper">
        <div className="m-RichText-container">
          <div className="dfb-Rte">
            <h6>{props.headline ? props.headline : "Weiterführende Links"}</h6>
            <p />
            <ul>
              {props.data.links.map((item, index) => (
                <li key={index}>
                  <MConditionalLink
                    link={item.link}
                    link_text={item.link_text}
                    link_obj={item.link_obj}
                  />
                </li>
              ))}
            </ul>
            <p />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MRelatedLinks
